import { advancedFlowSchema_ } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as z from "zod";

export const createAdvancedFlow = {
  name: "createAdvancedFlow" as const,
  input: z.object({
    newFlow: advancedFlowSchema_.omit({
      _id: true,
      createdAt: true,
      updatedAt: true,
      versionGroupId: true,
    }),
    setIndex: z.boolean(),
  }),
  output: z.object({ id: z.string() }),
};
